import { LotsScreen } from '../features/console';

export function LotsPage() {
  return <LotsScreen />;
}
